export default __webpack_public_path__ + "static/media/searchLogo.c0ff6805.png";